import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, Output } from "../../types"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Output>()

export function TableOutputs({
  outputs,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  outputs: Output[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!outputs) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [outputs, count])

  return (
    <Table
      data={outputs}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Nome"
        name="name"
        sortable
        width="minmax(max-content, 1fr)"
        render={(output) => (
          <Link to={`/outputs/outputs/${output.id}`}>
            <LinkMagik className="text-dark">{output.title}</LinkMagik>
          </Link>
        )}
        stickyLeft
        // TODO badge
      />
      <Table.Column
        title="Tipologia"
        name="record_media_type"
        sortable
        width="minmax(max-content, 1fr)"
        render={(output) => {
          return output.type
        }}
      />

      <Table.Column
        title="Ordine"
        name="order"
        sortable
        width="minmax(max-content, 1fr)"
        render={(output) => {
          return output.order
        }}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} output
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
